module.exports = __webpack_public_path__ + "562278e2f7360b7e60e819b27b5535eb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/scene-snapper.png
// module id = 3046
// module chunks = 0